import { AuxiliumComponent } from "../auxilium-component";

export default class InfoRow extends AuxiliumComponent {
	static observable = ["columns"];

	constructor() {
		super();

		this.columns = parseInt(this.getAttribute("columns")) || -1;

		this.classList.add("information-row");
	}

	parsedCallback() {
		if (this.columns === -1) {
			const columnCount = this.querySelectorAll("chip-infovalue").length;

			if (columnCount < 4) {
				this.columns = columnCount;
			}
		}
	}

	attributeChanged(name, _, newValue) {
		if (name === "columns") {
			this.columns = parseInt(newValue) || -1;
		}
	}
}
